/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../services';
import { FilterGroupAutoComplete, FilterValue, UserDisplayItem } from '../../../components';
import { useFilter } from '../useFilter';

interface UseAuthorsFilterArgs {
  filter: FilterValue[];
  fetchItemsQuery: any;
  fetchItemsQueryArgs?: any;
  groupId?: string;
  titleLocaliseKey?: string;
  placeholderLocaliseKey?: string;
}

//TODO make it more generic, get rid of 'Author' naming, e.g. useUsersFilter
//TODO OR create generic useUsersFilter and useAuthorsFilter will be its instance with pre-set author keys
export const useAuthorsFilter = ({
  filter,
  fetchItemsQuery,
  fetchItemsQueryArgs = {},
  groupId = 'authors',
  titleLocaliseKey = 'authorsFilter.title',
  placeholderLocaliseKey = 'authorsFilter.placeholder',
}: UseAuthorsFilterArgs) => {
  const { t } = useTranslation();

  const { getGroupById } = useFilter();

  const itemTemplate = useCallback((user: User) => <UserDisplayItem {...user} />, []);

  const autoComplete: FilterGroupAutoComplete = {
    propToIdentify: 'id',
    propToDisplay: 'screenName',
    fetchItemsQuery,
    fetchItemsQueryArgs,
    itemTemplate,
    placeholder: t(placeholderLocaliseKey),
  };

  return {
    group: {
      id: groupId,
      title: t(titleLocaliseKey),
      value: getGroupById({ filter, groupId })?.groupItems ?? [],
      allowReset: true,
      autoComplete,
    },
  };
};
